import template from './wizard_leave_setup_overview.html';

class WizardLeaveSetupOverview
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.recipients = ko.observableArray(); 
		this.leave_type_id = ko.observable(null); 
		this.leave_object = ko.observable(null); 
	};

	close()
	{
		this.dialog.close(true);
	}

	async edit_description()
	{
		Grape.dialog.open('WizardLeaveSetupDescription', {leave_type_id: this.dialog.bindings.leave_type_id, leave_object: this.leave_object()});
	}

	async edit_cycle()
	{
		Grape.dialog.open('WizardLeaveSetupCycle', {leave_type_id: this.dialog.bindings.leave_type_id, leave_object: this.leave_object()});
	}

	async edit_roles()
	{
		Grape.dialog.open('WizardLeaveSetupRoles', {leave_type_id: this.dialog.bindings.leave_type_id, leave_object: this.leave_object()});
	}

	async edit_linked_holidays()
	{
		Grape.dialog.open('WizardLeaveSetupHolidays', {leave_type_id: this.dialog.bindings.leave_type_id, leave_object: this.leave_object()});
	}

	async edit_linked_restriction_rules()
	{
		Grape.dialog.open('WizardLeaveSetupRestrictions', {leave_type_id: this.dialog.bindings.leave_type_id, leave_object: this.leave_object()});
	}

	async link_employees()
	{
		await Grape.dialog.open('WizardLeaveSetupEmployees', {leave_type_id: this.dialog.bindings.leave_type_id, recipients: this.recipients(), leave_object: this.leave_object(), data: this.leave_object()});
		this.dialog.updateData();
	}
};

class WizardLeaveSetupOverviewPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupOverview(this);
	};

	async updateData()
	{
		console.log('bindings', this.bindings);
		if (this.bindings.leave_type_id)
		{
			this.viewModel.leave_type_id(this.bindings.leave_type_id);
		
			//get leave type information
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_leave_types',
				schema: 'savanna',
				limit: 1000000,
				filter: [{ value: this.bindings.leave_type_id, op: '=', field: 'leave_type_id' }]
			});
			if (res.records)
				this.viewModel.leave_object(res.records[0]);
			else
			{
				//TODO: throw error for leave type not found
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'Leave type not found'});
				return;
			}

			//get leave type holidays
			let res_holidays = await Grape.fetches.getJSON('/api/record', {
				table: 'v_leave_type_linked_holidays',
				schema: 'savanna',
				limit: 1000000,
				filter: [{ value: this.bindings.leave_type_id, op: '=', field: 'leave_type_id' }]
			});

			if (res_holidays.records)
				this.viewModel.leave_object()['leave_type_linked_holidays'] = res_holidays.records;
	
			//get leave type restriction rules
			let res_rules = await Grape.fetches.getJSON('/api/record', {
				table: 'v_leave_type_linked_restriction_rules',
				schema: 'savanna',
				limit: 1000000,
				filter: [{ value: this.bindings.leave_type_id, op: '=', field: 'leave_type_id' }]
			});

			if (res_rules.records)
				this.viewModel.leave_object()['leave_type_linked_restriction_rules'] = res_rules.records;

			let employees = await Grape.fetches.postJSON('leave/get_employees_linked_to_leave_type', {
				leave_type_id: this.bindings.leave_type_id
			});

			let recipients = [];

			if (employees.length > 0)
			{
				for (let i = 0; i < employees.length; i++)
				{
					recipients.push({employee_id: employees[i].employee_id, start_date: employees[i].date_started});
					recipients[i].name =  employees[i].firstname + ' ' + employees[i].surname + ' (' + employees[i].id_number + ')';
					recipients[i].disable_edit = true;
				}
			}
			this.viewModel.recipients(recipients);
		}
	}
};

export default {
	name: 'WizardLeaveSetupOverview',
	dialog_class: WizardLeaveSetupOverviewPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_overview',
	provider: 'ps'
};
